// @module TavanoTeam.CSExtensions.CSCertCaptureExt.List.Cell.View
define('TavanoTeam.CSExtensions.CSCertCaptureExt.List.Cell.View'
,	[
		'tavanoteam_csextensions_cscertcaptureext_list_cell.tpl'

	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		tavanoteam_csextensions_cscertcaptureext_list_cell_tpl

	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class TavanoTeam.CSExtensions.CSCertCaptureExt.List.Cell.View @extends Backbone.View
	return Backbone.View.extend({

        template: tavanoteam_csextensions_cscertcaptureext_list_cell_tpl

		//@method getContext @return TavanoTeam.CSExtensions.CSCertCaptureExt.List.Cell.View.Context
	,   getContext: function getContext()
		{
			//@class TavanoTeam.CSExtensions.CSCertCaptureExt.List.View.Context
			return {
                columns: this.model.get('columns')
            ,   showViewBtn: this.model.get('filename') && this.model.get('filename') != ''
			,   id: this.model.get('internalid')
			,	enableRenewBtn: this.model.get('status') == 'EXPIRED'
			};
		}
	});
});
